import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, MuiThemeProvider } from '@material-ui/core';

import App from './components/App';
import Routes from './routes';
import theme from './theme';
import * as serviceWorker from './serviceWorker';
import handleCache from './collums-components/helpers/handleCache';
import './styles/index.css';

ReactDOM.render(
    <React.StrictMode>
        <CssBaseline />
        <MuiThemeProvider theme={theme}>
            <BrowserRouter>
                <App>
                    <Routes />
                </App>
            </BrowserRouter>
        </MuiThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

handleCache();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
if ('serviceWorker' in navigator) {
    navigator.serviceWorker
        .getRegistrations()
        .then(regs => Promise.all(regs.map(reg => reg.unregister())))
        .then(() => (typeof caches !== 'undefined' ? caches.keys() : []))
        .then(keys => Promise.all(keys.map(k => caches.delete(k))))
        .catch(() => {});
}
